import React, { Suspense } from 'react';
import { LazyLoadingSpinner } from './LazyLoadingSpinner';

interface LazyRouteWrapperProps {
  children: React.ReactNode;
  fallbackMessage?: string;
}

export const LazyRouteWrapper: React.FC<LazyRouteWrapperProps> = ({ 
  children, 
  fallbackMessage 
}) => {
  return (
    <Suspense fallback={<LazyLoadingSpinner message={fallbackMessage} />}>
      {children}
    </Suspense>
  );
};


export const withLazyRoute = <T extends Record<string, any>>(
  LazyComponent: React.LazyExoticComponent<React.ComponentType<T>>,
  fallbackMessage?: string
) => {
  return React.forwardRef<any, T>((props, ref) => (
    <LazyRouteWrapper fallbackMessage={fallbackMessage}>
      <LazyComponent {...props} ref={ref} />
    </LazyRouteWrapper>
  ));
}; 